import React, { useEffect, useState } from "react";

import actionIcon from "../../assets/img/icon/walletIcon.png";

import './toDo.css';
import { useNavigate } from "react-router-dom";

const FundWallet = ({ userDetails }) => {
  const navigate = useNavigate();
  const [isClickable, setIsClickable] = useState(false);

  const handleFundWallet = () => {
    navigate('/user/add_money');
  };

  return (
    <section className="toDoList-card rounded-2">
      <div className="toDo-container">
        <div className="toDo-icon">
          <img src={actionIcon} alt="KYC Verification" className="img-fluid" />
        </div>
        <div className="toDo-text">
          <h4>Fund Wallet</h4>
          <p>Add money to your wallet</p>
        </div>
        <button 
          className="toDo-button"
          disabled={isClickable}
          onClick={handleFundWallet}
        >
          Fund Now
          {/* {sdkLoaded ? "Verify Now" : "Loading..."} */}
        </button>
      </div>
    </section>
  );
};

export default FundWallet;